import { FullstateToAbvPipe } from '../../../../../../_helpers/_pipes/fullstate-to-abv.pipe';
import { SortPipe } from '../../../../../../_helpers/_pipes/sort.pipe';
import { DetailsSidebarComponent } from '../details-sidebar/details-sidebar.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { GetAddressService } from '../../../../../../_services/misc-services/get-address.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CompanyService } from '@services/my-insurance/company.service';
import { HostListener } from '@angular/core';
import { MortgageeCustomToolTipComponent } from '../../../../../widget/mortgagee-custom-tooltip/mortgagee-custom-tooltip.component';
import { HomeHeaderComponent } from '../../myinsurance-headers/home-header/home-header.component';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslatePipe, MapfreDesignLibraryModule, NgSelectModule, DetailsSidebarComponent, SortPipe, FullstateToAbvPipe, MortgageeCustomToolTipComponent, HomeHeaderComponent],
  selector: 'app-details-home',
  templateUrl: './details-home.component.html',
})
export class DetailsHomeComponent implements OnInit {
  @Input() policy: any;
  @Output() showToast: EventEmitter<any> = new EventEmitter<any>();
  address = 'address';
  apt = 'apt';
  aptDiv: boolean;
  safeURL: SafeUrl;
  showMessage = false;
  isAcmic: boolean;
  showCompany: string;
  isMobile:boolean;

  constructor(
    private getAddressService: GetAddressService,
    private acmicService: AcmicService,
    private companyService: CompanyService
  ) {
    this.detectStateCode();
  }
  detectStateCode() {
    this.isAcmic = this.acmicService.isACMIC();
  }
  getApartmentAndState(data): void {
    if (data.property != undefined || data.property != null) {
      const streetAddress = data.property[0].address.streetName;
      let addressArray = [];

      if (streetAddress.includes('|')) {
        addressArray = streetAddress.split('|');
        this.address = addressArray[0];
        this.apt = addressArray[1];
        this.aptDiv = true;
      } else {
        this.address = streetAddress;
        this.aptDiv = false;
      }
    }
  }

  ngOnInit() {
    this.getApartmentAndState(this.policy);
    this.safeURL = this.getAddressService.getAddress(this.policy, 'policy');
    this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
      
    });
    // This will need to be refactored.
    this.checkScreen();
  }
  @HostListener('window:resize')
  onResize(){
    this.checkScreen()
  }
  checkScreen(){
    this.isMobile = window.innerWidth<= 767;
  }
}
